import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class WorkerDTO {


    @ApiProperty()
    @IsOptional()
    workerId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "workerCode should not be empty" })
    @IsNumber()
    workerCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: "workerName should not be empty" })
    workerName: string;

    @ApiProperty()
    aadharCardNumber: string

    @ApiProperty()
    dateOfBirth: Date;


    @ApiProperty()
    address: string;


    @ApiProperty()
    contractorId: number;

    @ApiProperty()
    contractorName: string;


    @ApiProperty()
    dateOfJoining: Date;


    @ApiProperty()
    villageFrom: string;

    @ApiProperty()
    villageFromId: number;

    @ApiProperty()
    isActive: boolean;
    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
    createdUser: string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
}

